import { FunctionComponent } from 'react';

export type SeparatorCurveProps = {
  fill: string;
};

type FC = FunctionComponent<SeparatorCurveProps>;

const SeparatorCurvetop: FC = (props: SeparatorCurveProps) => {
  const { fill } = props;

  return (
    <svg width="390" height="41" viewBox="0 0 390 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 41L0 0L390 0V25.4551C244.96 27.1457 129.394 29.731 0 41Z" fill={fill} />
    </svg>
  );
};

export default SeparatorCurvetop;
